import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";
import { importOpenSidebar } from "../../../../redux/actions/openSidebar";
import { useDispatch } from "react-redux";
import { CurrencyIcon } from "src/utils/currencyIcon";
import { SetInitialBalanceIncludeInCashFlow } from "src/graphql/includeInCashFlow";
import { importUpdateBalanceNeeded, importUpdateCashflowNeeded } from "src/redux/actions/flujocaja";
import useBlockedFeatures from "src/hooks/useBlockedFeatures";
import ToolbarToggleSwitch from "src/components/shared/ToolbarToggleSwitch/ToolbarToggleSwitch";
import FeatherIcon from "feather-icons-react";

export default function AddedBalance({ manualDocuments, moment, toMoney }) {
  const { t } = useTranslation("finance");
  const dispatch = useDispatch();
  const [togglingId, setTogglingId] = useState(null);
  const { executeMutation: setIncludeInCashFlow } = SetInitialBalanceIncludeInCashFlow();
  const { canEditarSaldosFlujoCaja } = useBlockedFeatures();
  const canEdit = canEditarSaldosFlujoCaja();

  function editInitialBalance(selected) {
    dispatch(
      importOpenSidebar({
        show: true,
        editManualDocument: true,
        editData: selected,
      })
    );
  }

  const handleToggleIncludeInCashFlow = async (manualDocument, checked) => {
    if (!manualDocument?.id) return;
    setTogglingId(manualDocument.id);
    try {
      const result = await setIncludeInCashFlow({
        id: manualDocument.id,
        includeInCashFlow: checked,
      });
      if (result.data?.setInitialBalanceIncludeInCashFlow) {
        dispatch(importUpdateBalanceNeeded({ value: true }));
        dispatch(importUpdateCashflowNeeded({ value: true, reload: true }));
      } else if (result.error) {
        console.error('Error updating includeInCashFlow:', result.error);
      }
    } catch (error) {
      console.error('Error updating includeInCashFlow:', error);
    } finally {
      setTogglingId(null);
    }
  };

  return (
    <>
      <Grid columns={2}>
        <Grid.Row>
        {manualDocuments?.data?.allInitialBalanceDocumentsByCompany?.map(
          (manualDocument) => {
            const text =
              manualDocument?.currencyType == "CLP"
                ? ""
                : "(" + manualDocument?.currencyType + ")";
            const includedInCashFlow = manualDocument?.meta?.includeInCashFlow !== false;
            return (
              <Grid.Column key={manualDocument.id}>
              <div className={`initialBalanceContainer__balancesContainer__balancesCard ${!includedInCashFlow ? 'excludedFromCashFlowCard' : ''}`}>
                <div className="initialBalanceContainer__balancesContainer__balancesCard__title">
                  <span className="initialBalanceContainer__balancesContainer__balancesCard__title__content">
                    {manualDocument.name}
                  </span>
                  {!includedInCashFlow && (
                    <span className="excludedFromCashFlowBadge">
                      {t("cashflow.hiddenInCashFlow")}
                    </span>
                  )}
                </div>
                <div className="initialBalanceContainer__balancesContainer__balancesCard__date">
                  <span className="initialBalanceContainer__balancesContainer__balancesCard__date__content">
                    Agregado el{" "}
                    {moment(manualDocument.documentDate).format("DD/MM/yyyy")}
                  </span>
                </div>
                <div className="initialBalanceContainer__balancesContainer__balancesCard__description">
                  <span className="initialBalanceContainer__balancesContainer__balancesCard__description__content">
                    {manualDocument?.description || "Sin descripción"}
                  </span>
                </div>
                <div className="initialBalanceContainer__balancesContainer__balancesCard__lowerRow">
                  <div className="initialBalanceContainer__balancesContainer__balancesCard__lowerRow__description">
                    {`Monto ${text || ""}`}
                  </div>
                  <div className="initialBalanceContainer__balancesContainer__balancesCard__lowerRow__amount">
                    {`${CurrencyIcon?.[manualDocument?.currencyType]} ${
                      toMoney(manualDocument.amount, manualDocument?.currencyType || 'CLP', true) || 0
                    }`}
                  </div>
                </div>
                {canEdit && (
                  <div className="addedBalanceIncludeToggleWrap">
                    <ToolbarToggleSwitch
                      label={t("cashflow.includeInCashFlow")}
                      checked={includedInCashFlow}
                      disabled={togglingId === manualDocument.id}
                      onChange={(checked) => handleToggleIncludeInCashFlow(manualDocument, checked)}
                      className="addedBalanceIncludeToggle"
                    />
                    <button
                      type="button"
                      className="initialBalanceContainer__card__editBtn"
                      onClick={() => editInitialBalance(manualDocument)}
                      title={t("cashflow.update", { defaultValue: "Editar" })}
                      aria-label={t("cashflow.update", { defaultValue: "Editar" })}
                    >
                      <FeatherIcon icon="edit-2" size={16} />
                    </button>
                  </div>
                )}
              </div>
              </Grid.Column>
            );
          }
          )}
          </Grid.Row>
      </Grid>
    </>
  );
}
